import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import { Question } from '@/types/slide';
import { isCorrectnessDeterminable } from '@/utils/score';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ResultCorrectness: React.FC<{ question: Question }> = ({ question }) => {
    const { t } = useTranslation();

    // only care the latest answer
    const answer = question.answers[0];
    const scored = !isCorrectnessDeterminable(question) || answer?.correct;

    return (
        <Box
            sx={(theme) => ({
                backgroundColor: !answer ? 'transparent' : scored ? (theme.vars || theme).palette.success.main : (theme.vars || theme).palette.error.main,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                p: 1,
                borderRadius: '4px',
            })}
        >
            {!answer ? (
                <Typography variant='h5' color='warning' textAlign={'center'}>
                    {t('result.label.noResult')}
                </Typography>
            ) : scored ? (
                <CheckIcon style={{ color: 'white' }} />
            ) : (
                <CloseIcon style={{ color: 'white' }} />
            )}
        </Box>
    );
};
